var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-fw fa-circle-notch fa-spin text-primary",class:[`fa-${_vm.size}`]})])
}
var staticRenderFns = []

export { render, staticRenderFns }